/* global G */

import { hide, show } from 'lib/sequence/component/state/hidden'

/**
 * Displays the appropriate options for the current notification
 *
 * Looks for the current notification in the action state, thus requiring it to be
 * present there, e.g. by executing {@link getNotification} beforehand.
 *
 * @param {Gaia.AppModule.Spec} module current module composition
 * @returns {function(*, ...[*]): Promise<*[]>}
 */
export const displayOptions = module => async (components, ...args) => {
  const { markAsRead, markAsUnread } = components

  const actionState = module[G.STATE][G.ACTION][G.STATE]
  const { notification } = actionState
  const isRead = notification.value?.read?.length

  isRead
    ? show(markAsUnread) && hide(markAsRead)
    : show(markAsRead) && hide(markAsUnread)

  return args
}
